import React, { useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import VVSTable from "components/form-control/VVSTable";
import moment from "moment";
import IDatePicker from "components/Common/DatePicker";

const AccountAdmin = () => {
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const onHandleFilterDate = () => {
    if (dateFrom || dateTo) {
      return {
        userType: "internal",
        createdAt: {
          ...(dateFrom && {
            $gte: {
              __type: "Date",
              iso: moment(new Date(dateFrom)).startOf("day"),
            },
          }),
          ...(dateTo && {
            $lte: {
              __type: "Date",
              iso: moment(new Date(dateTo)).endOf("day"),
            },
          }),
        },
      };
    }

    return {
      userType: "internal",
    };
  };

  useEffect(() => {
    onHandleFilterDate();
  }, [dateFrom, dateTo]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row
          style={{
            position: "relative",
            marginBottom: "-35px",
            zIndex: 99,
            width: "max-content",
          }}
        >
          <h4 className="my-0 font-size-18 text-capitalize mb-2">
            Tài khoản QTV
          </h4>
          <div className="d-flex align-items-center">
            <div>
              <IDatePicker
                label="Từ ngày: "
                placeholder="Từ ngày"
                value={dateFrom}
                onChange={value => setDateFrom(value)}
              />
            </div>
            <div>
              <IDatePicker
                label="Đến ngày: "
                placeholder="Đến ngày"
                value={dateTo}
                onChange={value => setDateTo(value)}
              />
            </div>
          </div>
        </Row>
        <VVSTable
          name="AccountAdmin"
          enableInlineEdit={false}
          whereQuery={onHandleFilterDate()}
        />
      </Container>
    </div>
  );
};

export default AccountAdmin;
